import Config from '@config';
import type { DeliveryPickerNavigationStateType } from '@organisms/DeliverySelector/DeliverySelector';

export type DeliveryPickerTitleKey =
  | 'titles.chooseDeliveryMode'
  | 'titles.pickUpInStore'
  | 'titles.homeDelivery'
  | 'titles.homeDelivery_b2b'
  | 'titles.chooseSlot';

export type DeliveryPickerBoxHomeDeliveryKey = 'box.homeDelivery' | 'box.homeDelivery_b2b';

export type DeliveryPickerErrorKey = 'delivery.slotIsNull';

export function getDeliveryPickerTitleKey(
  state: DeliveryPickerNavigationStateType,
  isB2B: boolean
): DeliveryPickerTitleKey {
  if (state === Config.HOME_DELIVERY && isB2B) {
    return 'titles.homeDelivery_b2b';
  }
  if (state === 'chooseDeliveryMode') return 'titles.chooseDeliveryMode';
  if (state === 'pickUpInStore') return 'titles.pickUpInStore';
  if (state === Config.HOME_DELIVERY) return 'titles.homeDelivery';
  if (state === 'chooseSlot') return 'titles.chooseSlot';
  return 'titles.chooseDeliveryMode';
}

export function getDeliveryPickerBoxHomeDeliveryKey(isB2B: boolean): DeliveryPickerBoxHomeDeliveryKey {
  return isB2B ? 'box.homeDelivery_b2b' : 'box.homeDelivery';
}

export function getDeliveryPickerErrorKey(errorMessage: string): DeliveryPickerErrorKey | null {
  if (errorMessage === 'delivery.slot.is.null') {
    return 'delivery.slotIsNull';
  }
  return null;
}
